// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__2x9UF","sidebar__slide":"Sidebar_sidebar__slide__3Qx1G","sidebar__inner":"Sidebar_sidebar__inner__ZjmU5"};